import React from "react"
const PrivacyProtection = () => {
  return (
    <>
      <section>
        <div className="container">
          <div className="row">
            <div className="col-12 col-md-12 ">
             
                <h3 className="component-domain">
                  Keey away from spammers
                </h3>
                <h3 className="content-domain">Privacy Protection</h3>
                <div className="description py-2">
                  It's crucial to stay vigilant against spammers and protect
                  your privacy, especially when registering domains. Privacy
                  Protection services offered by registrars like Motherhost can
                  be essential in safeguarding your personal information from
                  being publicly accessible on whois websites.
                </div>

                <div className="description py-2">
                  When you opt for Privacy Protection, your registrar typically
                  replaces your personal details with those of a proxy service
                  like Domains By Proxy. This way, your name, address, email,
                  and phone number remain hidden from public view, reducing the
                  risk of being targeted by hackers, spammers, and marketers who
                  exploit such information for unsolicited emails and domain
                  theft.
                </div>
                <div className="description py-2">
                  By investing in Privacy Protection, you can mitigate the risks
                  associated with domain registration and maintain greater
                  control over your online privacy and security.
                </div>
             
            </div>
          </div>
        </div>
      </section>
    </>
  )
}

export default PrivacyProtection
